import {Component, OnInit} from '@angular/core';
import {SolrService} from "../../services/solr.service";
import {FiltersService} from "../../services/filters.service";

@Component({
  selector: 'app-types',
  templateUrl: './types.component.html',
  styleUrls: ['./types.component.scss']
})
export class TypesComponent implements OnInit {
  defaults: any;
  filters: any;
  constructor(private solrService: SolrService,
              private filtersService: FiltersService) {
    this.filtersService.filters.subscribe((filters: any) => {
      this.filters = filters;
    });
    this.solrService.defaults.subscribe((defaults:any) => {
      this.defaults = defaults;
    })
  }

  ngOnInit(): void {
  }
  toggle(name:string, checked:boolean){
    let i = this.filters.firework_types.indexOf(name);
    if(checked && i === -1){
      this.filters.firework_types.push(name);
    }
    else if(!checked && i !== -1){
      this.filters.firework_types.splice(i, 1);
    }
    this.filtersService.setFilters(this.filters);
  }
  opened(){
    this.filters.expanded.firework_types = true;
    this.filtersService.setFilters(this.filters);
  }
  closed(){
    this.filters.expanded.firework_types = false;
    this.filtersService.setFilters(this.filters);
  }

}
